import PropTypes from 'prop-types';
import React from 'react';
import Badge from './badge';
const FollowupHeader = _ref => {
  let followup = _ref.followup,
    isOpen = _ref.isOpen,
    onToggle = _ref.onToggle,
    hasDetails = _ref.hasDetails;
  const hasAnalysis = !!followup.analysis;
  if (!hasDetails) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-3 flex-wrap"
    }, /*#__PURE__*/React.createElement(Badge, {
      tag: "span",
      color: "primary",
      pill: true,
      className: "quality-agent__status-badge"
    }, "Priority ", followup.priority), /*#__PURE__*/React.createElement("span", {
      className: "fw-medium"
    }, followup.description), hasAnalysis && /*#__PURE__*/React.createElement(Badge, {
      tag: "span",
      color: "success",
      pill: true,
      className: "quality-agent__status-badge"
    }, "Analyzed")));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center quality-agent__prior-runs-toggle",
    onClick: onToggle,
    role: "button",
    tabIndex: 0,
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onToggle();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 flex-wrap"
  }, /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: "primary",
    pill: true,
    className: "quality-agent__status-badge"
  }, "Priority ", followup.priority), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, followup.description), hasAnalysis && /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: "success",
    pill: true,
    className: "quality-agent__status-badge"
  }, "Analyzed")), /*#__PURE__*/React.createElement("span", {
    className: "text-muted small"
  }, isOpen ? '▲' : '▼'));
};
FollowupHeader.propTypes = {
  followup: PropTypes.shape({
    priority: PropTypes.number,
    description: PropTypes.string,
    analysis: PropTypes.shape({})
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  hasDetails: PropTypes.bool.isRequired
};
export default FollowupHeader;